import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem } from '../../__styling'

export const StyledAppDownloadTitle = styled('h2')(({ theme }) => ({
    color: theme.colors.text.heading,
    fontFamily: theme.fonts.heading,
    fontWeight: 700,

    margin: 0,
    padding: 0,

    // Smaller text styling for mobile devices
    fontSize: calcRem(32),
    lineHeight: calcRem(40),

    // Laptop and larger devices have larger text than the mobile versions
    [breakpoint('sm')]: {
        fontSize: calcRem(48),
        lineHeight: calcRem(64),
    },
}))

export const StyledAppDownloadSubText = styled('p')(({ theme }) => ({
    color: tokens.perthnow.colors.palette.greyDavy,
    fontFamily: theme.fonts.sansSerif,
    fontSize: calcRem(18),
    fontWeight: 400,
    lineHeight: calcRem(28),

    margin: 0,
    padding: 0,

    // Make sure to display the mobile text on mobile devices
    '&.mobile-text': {
        display: 'block',
    },
    '&.web-text': {
        display: 'none',
    },

    // When displaying bigger than a mobile, show the shorter text
    [breakpoint('sm')]: {
        '&.mobile-text': {
            display: 'none',
        },
        '&.web-text': {
            display: 'block',
        },
    },
}))
